import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { BarChart3, Bell, FileText, FlaskConical, Inbox, Megaphone, RefreshCw, Send, Settings, Truck, Users } from 'lucide-react';
import { WHATSAPP_TABS } from '../../models/MasterAdmin/whatsappHub';
import { waSubNavClass, waSubNavItem } from './whatsappUi';

const TAB_ICONS: Record<string, React.ReactNode> = {
  inbox: <Inbox className="h-5 w-5" />,
  send: <Send className="h-5 w-5" />,
  testing: <FlaskConical className="h-5 w-5" />,
  contacts: <Users className="h-5 w-5" />,
  campaigns: <Megaphone className="h-5 w-5" />,
  templates: <FileText className="h-5 w-5" />,
  notifications: <Bell className="h-5 w-5" />,
  retargeting: <RefreshCw className="h-5 w-5" />,
  delivery: <Truck className="h-5 w-5" />,
  analytics: <BarChart3 className="h-5 w-5" />,
  settings: <Settings className="h-5 w-5" />,
};

const WhatsAppSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <aside className={waSubNavClass} aria-label="WhatsApp modules">
      <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-xl bg-[#25D366]/15 text-[#25D366]">
        <Inbox className="h-5 w-5" />
      </div>
      {WHATSAPP_TABS.map((tab) => {
        const active =
          tab.id === 'inbox'
            ? location.pathname === tab.path || location.pathname === `${tab.path}/`
            : location.pathname.startsWith(tab.path);
        return (
          <NavLink
            key={tab.id}
            to={tab.path}
            title={tab.label}
            className={waSubNavItem(active)}
          >
            {TAB_ICONS[tab.id]}
          </NavLink>
        );
      })}
    </aside>
  );
};

export default WhatsAppSidebar;
